export default __webpack_public_path__ + "static/media/super-trunfo.583da63c.svg";